import { IconPlayClean } from './icons';
import { Icon, IconButton, Spinner } from './styles';
import { __t } from './i18n';

const PlayButton = ({ loading }: { loading: boolean }) => (
  <IconButton
    block
    variant="primaryA"
    round
    p={{ xs: 1, md: 2 }}
    isPlay
    aria-label={__t('content.watch')}
  >
    {loading ? <Spinner /> : <PlayIcon />}
  </IconButton>
);

export const PlayIcon = () => (
  <Icon cursor="pointer">
    <IconPlayClean />
  </Icon>
);

export default PlayButton;
